<template>
  <v-container fluid grid-list-md>
    <v-row v-if="fundInfoLoaded">
      <v-col>
        <h1 class="text-subtitle-1 ma-0">Detalhes do fundo</h1>
      </v-col>
      <v-col>
        <div class="text-right date-select">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <span
                  v-text="formatDate(startDate)"
                  label="Data inicial"
                  readonly
                  v-on="on"
                ></span>
              </template>
              <v-date-picker v-model="startDate" @input="startDateMenu = false"></v-date-picker>
            </v-menu>
            até
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <span
                  v-text="formatDate(endDate)"
                  label="Data inicial"
                  readonly
                  v-on="on"
                ></span>
              </template>
              <v-date-picker v-model="endDate" @input="endDateMenu = false"></v-date-picker>
            </v-menu>
        </div>
      </v-col>
    </v-row>

    <template v-if="hasFoundFund">
      <BasicInformation
        :fund="fund"
        :loading="loading"
        :user="user"
        @update:fund="() => getData(endDate)"
      />

      <ReturnTable
        :fundId="fund._id"
      />

      <ReturnChart
        v-if="fundInfoLoaded"
        :fundId="fund._id"
        :benchmarkId="fund.benchmark._id"
        :benchmarkName="fund.benchmark.name"
        :endDate="endDate"
        :startDate="startDate"
      />
    </template>
  </v-container>
</template>

<style lang="scss" scoped>
.date-select {
  .v-menu {
    display: inline-block;
  }
  > span {
    cursor: pointer;
    border-bottom: dotted 1px rgba(0,0,0,.87);
  }
}
</style>

<script>
import moment from 'moment-loyall';
import api from '@/services/api';
import store from '@/services/store';

// Components
import BasicInformation from '../components/BasicInformation.vue';
import ReturnChart from '../components/ReturnChart.vue';
import ReturnTable from '../components/ReturnTable.vue';

export default {
  components: {
    BasicInformation,
    ReturnChart,
    ReturnTable,
  },

  data: () => ({
    startDateMenu: false,
    startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
    endDateMenu: false,
    endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    id: '',
    fund: null,
    fundInfoLoaded: false,
    loading: true,
  }),

  computed: {
    user: (vm) => vm.$store.getters.user,
    hasFoundFund: (vm) => vm.fund && Object.keys(vm.fund).length > 0,
  },

  watch: {
    async endDate(date) {
      await this.getData(date);
    },
    async $route(to) {
      const { fundId } = to.params;
      if (fundId) {
        this.id = fundId;
        await this.getData(undefined, true);
      }
    },
  },

  async mounted() {
    await this.getData(undefined, true);
  },

  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    async getData(date, limitQuery = false) {
      store.dispatch('layout/setLoadingState', true);
      this.loading = true;
      this.fund = null;

      this.id = this.$route.params.fundId;
      const { data: { fund } } = await api.funds.getById(this.id, {
        params: {
          date,
        },
      });
      this.fund = fund;
      this.fundInfoLoaded = true;

      if (fund.initialDate) {
        this.startDate = moment(fund.initialDate).tz('UTC').format('YYYY-MM-DD');
        if (limitQuery && moment(moment()).diff(fund.initialDate, 'years', false) > 5) {
          this.startDate = moment().tz('UTC').subtract(5, 'years').format('YYYY-MM-DD');
        }
      }

      // Get Fund information
      const {
        data: { history: fundHistory },
      } = await api.funds.returnsById(this.id, {
        params: {
          endDate: this.endDate,
          startDate: this.startDate,
        },
      });

      fundHistory.sort((a, b) => new Date(b.date) - new Date(a.date));

      fundHistory.forEach((history) => {
        if (history.value && history.quotaholders && !this.fund.lastCompleteInfo) {
          this.fund.lastCompleteInfo = history;
        }
      });

      this.loading = false;
      store.dispatch('layout/setLoadingState', false);
    },
  },
};
</script>
